import { WOW } from "wowjs";
/* eslint-disable-next-line */
(function ($, ajax_localize) {
    $(document).on("ready", function () {
        const wow = new WOW();

        wow.init();

        let body = $("body");

        //always show the alert on page load even if is was closed
        $("#alert-system").show();
        $("body").removeClass("alert-hidden");

        /**
         * Mobile Menu
         */

        $("header .mobile-menu-toggle").on("click", function () {
            $("body").toggleClass("no-scroll");
        });

        $("#mobile-menu-collapse")
            .find(
                ".menu-item-has-children > .sub-menu, " +
                    ".dropdown-panel .sub-fund-type-products-list .product-list-items"
            )
            .each(function () {
                $(this).addClass("mobile-menu-sub-level-panel");

                let subLevelTitleElement = $("<h3>").html(
                    $(this).siblings(".nav-link").html().trim()
                );

                if (
                    $(this).hasClass("sub-menu-mega-menu") ||
                    $(this).hasClass("dropdown-panel")
                ) {
                    $(this).prepend(
                        $("<div>")
                            .addClass("sub-level-panel-heading")
                            .append(subLevelTitleElement)
                    );
                } else {
                    $(this).prepend(
                        $("<li>")
                            .addClass("sub-level-panel-heading")
                            .append(subLevelTitleElement)
                    );
                }
            });

        $("#mobile-menu-collapse")
            .on("show.bs.collapse", function () {
                let headerBannerHeight = $(
                    "body > header > div:visible"
                ).outerHeight();

                let adminBarHeight = $("#wpadminbar").length
                    ? $("#wpadminbar").outerHeight()
                    : 0;

                let alertBarHeight =
                    $("#alert-system").length &&
                    $("#alert-system").is(":visible")
                        ? $("#alert-system").outerHeight()
                        : 0;

                $(this)
                    .css("display", "")
                    .css(
                        "--mobile-menu-height",
                        $(window).outerHeight() -
                            headerBannerHeight -
                            adminBarHeight -
                            alertBarHeight +
                            "px"
                    );

                $(this).children(".mobile-menu-wrap").addClass("curr-level");
            })
            .on("hidden.bs.collapse", function () {
                $(this).find(".curr-level").removeClass("curr-level");

                $(this).find(".show").removeClass("show fade-in");

                $(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

                $(this).find(".js-menu-back-btn").data("depth-level", 0);
            });

        let mobileMenuBackBtnWrap = $("#mobile-menu-collapse").find(
            ".back-btn-wrap"
        );
        let mobileMenuBackBtn =
            mobileMenuBackBtnWrap.children(".js-menu-back-btn");

        mobileMenuBackBtn.data("depth-level", 0);

        mobileMenuBackBtn.on("click", function () {
            $(this).data("depth-level", $(this).data("depth-level") - 1);

            let currentMenuPanel = $("#mobile-menu-collapse").find(
                ".mobile-menu-sub-level-panel.curr-level"
            );

            currentMenuPanel
                .parent()
                .closest(".mobile-menu-sub-level-panel")
                .addClass("curr-level");

            currentMenuPanel
                .addClass("fade-out")
                .removeClass("show fade-in curr-level");

            if ($(this).data("depth-level") <= 0) {
                $("#mobile-menu-collapse")
                    .find(".mobile-menu-wrap")
                    .addClass("curr-level");

                $(this)
                    .data("depth-level", 0)
                    .parent()
                    .addClass("fade-out")
                    .removeClass("show fade-in");
            }
        });

        $("#mobile-menu-collapse")
            .find(
                ".wp-menu > .menu-item-has-children > .nav-link," +
                    ".mega-menu-nav > .has-dropdown-panel > .nav-link," +
                    ".dropdown-panel .sub-fund-type-products-list > .nav-link"
            )
            .on("click", function (evt) {
                evt.preventDefault();

                $("#mobile-menu-collapse")
                    .find(".curr-level")
                    .removeClass("curr-level");

                let parentScrollOffset = $(this)
                    .closest(".mobile-menu-sub-level-panel, .mobile-menu-wrap")
                    .scrollTop();

                $(this)
                    .siblings(".mobile-menu-sub-level-panel")
                    .css(
                        "top",
                        $(this)
                            .closest(
                                ".mobile-menu-sub-level-panel, .mobile-menu-wrap"
                            )
                            .scrollTop()
                    )
                    .scrollTop(0)
                    .removeClass("fade-out")
                    .addClass("show fade-in curr-level");

                if (mobileMenuBackBtn.data("depth-level") < 1) {
                    mobileMenuBackBtnWrap
                        .css("top", parentScrollOffset)
                        .removeClass("fade-out")
                        .addClass("show fade-in");
                }

                mobileMenuBackBtn.data(
                    "depth-level",
                    mobileMenuBackBtn.data("depth-level") + 1
                );

                return false;
            });

        //normalize the height of alerts
        function alertCarouselNormalization() {
            var items = $("#alert-system .carousel-item"), //grab all slides
                heights = [], //create empty array to store height values
                tallest; //create variable to make note of the tallest slide

            if (items.length) {
                normalizeHeights(items, heights, tallest);

                $(window).on("resize orientationchange", function () {
                    (tallest = 0), (heights.length = 0); //reset vars
                    items.each(function () {
                        $(this).css("min-height", "0"); //reset min-height
                    });
                    normalizeHeights(items, heights, tallest); //run it again
                });
            }
        }

        alertCarouselNormalization();

        function normalizeHeights(items, heights, tallest) {
            items.each(function () {
                //add heights to array
                heights.push($(this).height());
            });
            tallest = Math.max.apply(null, heights); //cache largest value
            items.each(function () {
                $(this).css("min-height", tallest + "px");
                $(this)
                    .find(".wrapper")
                    .css("min-height", tallest + "px");
            });
        }

        /**
         * Single Post
         * Progress bar functionality
         */
        if (body.hasClass("single-post")) {
            let article = document.getElementById("article-bottom");
            let footer = $("#post-footer");
            let progressBar = footer.find("#progress");
            let articleBottom = article.offsetTop;

            $(window).on("scroll", function () {
                let windowHeight = window.innerHeight;
                let windowScroll = window.scrollY;

                if (windowScroll + windowHeight < articleBottom) {
                    let percentage =
                        Math.floor(
                            ((windowScroll + windowHeight) / articleBottom) *
                                100
                        ) + 1;
                    $(progressBar).css("width", percentage + "%");
                }
            });
        }

        $(".menu-item-has-children")
            .find(".dropdown-toggle")
            .attr("data-toggle", "");

        // let headerHeight = ($( '.site-header' ).height() - 10);
        // $('#content').css('padding-top', headerHeight);

        $(".scroll-down-container").click(function () {
            let header_height = $(".site-header").outerHeight();
            let carousel_height = $(".carousel-block").outerHeight();
            window.scrollTo(0, carousel_height - header_height);
        });

        //pause video on modal close
        $(document).on("click", ".orange-youtube-video-modal", function (e) {
            let isIframe = $(this).find("iframe").length > 0;
            //if is's a youtube iframe
            if (isIframe) {
                let videoIframeSource = $(this).find("iframe")[0].src;
                //reset the source to pause the video
                $(this).find("iframe")[0].src = videoIframeSource;
            } else {
                //if it's a hosted video
                let isHostedVideo = $(this).find("video").length > 0;
                if (isHostedVideo) {
                    //if clicked outside the video, then pause
                    if (e.target.tagName != "VIDEO") {
                        $(this).find("video")[0].pause();
                    }
                }
            }
        });

        //show and hide back to top button
        var scrollTimeout;
        $(window).scroll(function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function () {
                if (
                    document.body.scrollTop > 200 ||
                    document.documentElement.scrollTop > 200
                ) {
                    $("#back-to-top").css("opacity", "1");
                } else {
                    $("#back-to-top").css("opacity", "0");
                }
            }, 300);
        });

        /*
                Mega Menu
         */

        if (window.innerWidth > 767) {
            $(".menu-shop").hover(
                function () {
                    $(".site-header").addClass("mega-menu-open");
                    $(".menu-shop").addClass("mega-menu-open-nav");
                },
                function () {
                    if (
                        $("#mega-menu").is(":hover") ||
                        $("#mega-menu").is(":focus")
                    ) {
                        $(".site-header").addClass("mega-menu-open");
                        $(".menu-shop").addClass("mega-menu-open-nav");
                    } else {
                        $(".site-header").removeClass("mega-menu-open");
                        $(".menu-shop").removeClass("mega-menu-open-nav");
                    }
                }
            );
        }

        $("#mega-menu").hover(
            function () {
                $(".site-header").addClass("mega-menu-open");
                $(".menu-shop").addClass("mega-menu-open-nav");
            },
            function () {
                if ($(".menu-shop:hover").length) {
                    $(".site-header").addClass("mega-menu-open");
                    $(".menu-shop").addClass("mega-menu-open-nav");
                } else {
                    $(".site-header").removeClass("mega-menu-open");
                    $(".menu-shop").removeClass("mega-menu-open-nav");
                }
            }
        );

        $("#search-trigger").on("click", function () {
            if (
                $("#alert-system").length &&
                $("#alert-system").is(":visible")
            ) {
                let alert_height = $("#alert-system").outerHeight();
                $(".search-header-container")
                    .removeClass("active")
                    .css({ top: alert_height + "px" });
            }
            $(".search-header-container").toggleClass("active");
        });

        $("#search-close").click(function () {
            $(".search-header-container")
                .removeClass("active")
                .css({ top: "" });
        });

        /*
                Profile Menu
         */

        let profileMenuLink = $("#profile-menu-link");

        let profileMenuTimeout;

        if (window.innerWidth > 767) {
            profileMenuLink.hover(
                function () {
                    clearTimeout(profileMenuTimeout);
                    $(".account-menu-wrapper").removeClass("hidden");
                },
                function () {
                    profileMenuTimeout = setTimeout(function () {
                        if (!$(".account-menu-wrapper").is(":hover")) {
                            $(".account-menu-wrapper").addClass("hidden");
                        }
                    }, 200);
                }
            );

            $(".account-menu-wrapper").mouseover(function () {
                profileMenuLink.addClass("hovered");
            });

            $(".account-menu-wrapper").mouseleave(function () {
                $(this).addClass("hidden");
                profileMenuLink.removeClass("hovered");
            });
        }

        //tabs on woocommerce registration screen
        // Updates browser's address bar by adding click tab's ID and a hash value, to simulate page navigation
        $("#customer_login #account-tabs .nav-link ").each(function () {
            $(this).on("click", function () {
                const tabId = $(this).attr("href");
                window.history.pushState(null, null, tabId);
            });
        });

        //If the url contains a hash open the tab if it exists

        if (window.location.hash !== "") {
            const linkedRegistrationTab = $(
                "#customer_login #account-tabs"
            ).find("a[href='" + window.location.hash + "']");

            if (linkedRegistrationTab.length > 0) {
                linkedRegistrationTab.click();
            }
        }

        //change the text in the user role dropdown on woocommerce registeration screen
        let userRoleSelect = $(
            ".afreg_extra_fields select#afreg_select_user_role"
        );

        if (userRoleSelect.length) {
            //place holder
            userRoleSelect
                .children("option")
                .eq(0)
                .text("Please select an option");

            //retail customer
            userRoleSelect
                .children("option")
                .eq(1)
                .append(" – I am shopping for my home or business.");

            //trade customer
            userRoleSelect
                .children("option")
                .eq(2)
                .append(
                    " – I am an Architect, Builder, Contractor, or Designer buying for my clients."
                );
        }

        //add the title to the top of the compare page
        if ($("body").hasClass("compare")) {
            $(".content-wrap").prepend(
                `<div class="product-compare-top">
                <a href="/shop" class="fancy-link">Back to All Products</a>
                <h1>Product Comparison</h1>
              </div>`
            );
        }

        //remove the word 'indicator' from 'stock indicator'
        if ($("body").hasClass("compare")) {
            let stockIndicatorTitle = $('th:contains("Stock Indicator")');
            if (stockIndicatorTitle.length) {
                stockIndicatorTitle.text("Stock");
            }
        }

        //add the link to home after a trade customer registers
        if ($("body").hasClass("my-account")) {
            if (getUrlVars().approved == "pending#create-account") {
                $("p.enu_warning").append(
                    `<br><a  href="/" class="fancy-link link-back-to-home">Back to Home</a>`
                );
            }
        }

        // Read a page's GET URL variables and return them as an object.
        function getUrlVars() {
            var vars = {},
                hash;
            var hashes = window.location.href
                .slice(window.location.href.indexOf("?") + 1)
                .split("&");
            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split("=");

                vars[hash[0]] = hash[1];
            }
            return vars;
        }

        //on the login/create-account page(my account) open the tab when the navigation menu is clicked
        if ($("body").hasClass("my-account")) {
            let loginNavLink = $("#login-nav-link");
            let createAccountNavLink = $("#create-account-nav-link");

            if ((loginNavLink.length > 0, createAccountNavLink.length > 0)) {
                loginNavLink.click(function () {
                    $("#login-tab").click();
                });

                createAccountNavLink.click(function () {
                    $("#create-account-tab").click();
                });
            }
        }

        //single product page
        if ($("body").hasClass("single-product")) {
            //open the description tab when the "more details" link is clicked
            $("a#product-description-link").click(function () {
                $("#tab-title-description a").trigger("click");
            });

            //hide the "TEMPORARILY OUT OF STOCK" link if there's no recommended products on the page
            let similarProductsLink = $(".sold-out a");
            let hasRecommendedProducts =
                $("#similar-products div.product").length > 0;
            if ((similarProductsLink.length > 0, !hasRecommendedProducts)) {
                similarProductsLink.hide();
            }

            //add the "TEMPORARILY OUT OF STOCK" to out-of-stock composite products
            let compositeAvailabilityDiv = $("div.composite_availability");

            if (
                compositeAvailabilityDiv.length > 0 &&
                compositeAvailabilityDiv.find(
                    "p.out-of-stock,p.available-on-backorder"
                ).length > 0 &&
                hasRecommendedProducts
            ) {
                //for some reason appending doesn't work without setTimeout
                setTimeout(function () {
                    compositeAvailabilityDiv
                        .first()
                        .append(
                            '<a href="#similar-products" class="h6 inline-link">See Similar Products</a>'
                        );
                }, 200);
            }

            //add a class to the availability div for in-stock  products (to hide with css)
            if (
                compositeAvailabilityDiv.length > 0 &&
                compositeAvailabilityDiv.find("p.in-stock").length > 0
            ) {
                compositeAvailabilityDiv.addClass("hide-availability");
            }

            //add a class to the availability div for available-on-backorder products
            if (
                compositeAvailabilityDiv.length > 0 &&
                compositeAvailabilityDiv.find("p.available-on-backorder")
                    .length > 0
            ) {
                compositeAvailabilityDiv.addClass("product-on-backorder");
            }

            //listen to the "show_variation" event which happens when a variation is selected. Then get that variation's specs from the backend and finally update the specs table
            $(".single_variation_wrap").on(
                "show_variation",
                function (event, variation) {
                    let variationID = variation.variation_id;

                    //ajax request to get the variation specs
                    var data = {
                        variation_id: variationID,
                        action: "get_product_variation_specs",
                    };

                    jQuery.post(
                        ajax_localize.ajax_url,
                        data,
                        function (response) {
                            let specsObject = JSON.parse(response);

                            //update the specs table only if the specs object isn't empty
                            if (Object.keys(specsObject).length > 0) {
                                let specsTableHTML = "";

                                for (let specName in specsObject) {
                                    specsTableHTML += `
                                    <tr>
                                    <th>${specName}</th> <td>${specsObject[specName]}</td>
                                    </tr>
                                    `;
                                }
                                $("#specifications-table").html(specsTableHTML);
                            }
                        }
                    );
                }
            );
        }

        //open the Olark chat when the "Chat with us" link is clicked (href should be #chat)
        let chatWithUsBtn = $(
            'section.link-list-block a.list-group-item[href="#chat"]'
        );
        //if the chat button exists, add the event listener
        if (chatWithUsBtn.length) {
            chatWithUsBtn.click(function (e) {
                e.preventDefault();
                /* eslint-disable-next-line */
                olark("api.box.expand");
            });
        }

        // decrease the z-index of the olark widget on the quiz page so it won't cover the quiz buttons
        if ($("body").hasClass("quiz")) {
            /* eslint-disable-next-line */
            olark("api.box.hide");

            /* eslint-disable-next-line */
            olark("api.chat.onReady", function () {
                setTimeout(() => {
                    $(".olark-launch-button-wrapper").css(
                        "cssText",
                        `z-index: 5000 !important`
                    );
                    $("#olark-container").css(
                        "cssText",
                        `z-index: 5000  !important`
                    );

                    /* eslint-disable-next-line */
                    olark("api.box.show");
                }, 1000);
            });
        }

        //move the olark widget up on single posts on desktop
        if ($("body").hasClass("single-post") && window.innerWidth > 991) {
            /* eslint-disable-next-line */
            olark("api.box.hide");

            /* eslint-disable-next-line */
            olark("api.chat.onReady", function () {
                setTimeout(() => {
                    $(".olark-launch-button-wrapper").css(
                        "cssText",
                        `bottom: 100px !important`
                    );
                    $("#olark-container").css(
                        "cssText",
                        `bottom: 170px !important`
                    );

                    /* eslint-disable-next-line */
                    olark("api.box.show");
                }, 1000);
            });
        }

        //move the olark widget and the BTT button up on product archive pages when the compare tray is open
        if (
            $("body").is(
                ".woocommerce-shop , .tax-product_cat , .tax-product_brand , .page-template-new-sale-page"
            )
        ) {
            //select the compare tray
            const compareTray = document.querySelector(
                ".berocket_show_compare_toolbar"
            );

            //if the compare tray exists on the page then move the chatwidget
            if (compareTray) {
                if (compareTray.style.display !== "none") {
                    document.getElementById("back-to-top").style.bottom =
                        "60px";
                }

                try {
                    /* eslint-disable-next-line */
                    olark("api.box.hide");

                    /* eslint-disable-next-line */
                    olark("api.chat.onReady", function () {
                        //set the right position on page load
                        setTimeout(() => {
                            if (compareTray.style.display !== "none") {
                                $(".olark-launch-button-wrapper").css(
                                    "cssText",
                                    `z-index: 20 !important; bottom: 60px !important; transition:0.2s ease-in;`
                                );
                            }
                            /* eslint-disable-next-line */
                            olark("api.box.show");
                        }, 1000);
                    });
                } catch (e) {
                    console.log(e);
                }

                //create a mutaion observer to observe the compare tray. when the tray changes it'll set the position of the BTT button and the chat widget
                const compareTrayMutationObserver = new MutationObserver(() => {
                    if (compareTray.style.display === "none") {
                        $(".olark-launch-button-wrapper").css(
                            "cssText",
                            `z-index: 20 !important; bottom: 15px !important; transition:0.2s ease-in;`
                        );
                        document.getElementById("back-to-top").style.bottom =
                            "10px";
                    } else {
                        $(".olark-launch-button-wrapper").css(
                            "cssText",
                            `z-index: 20 !important; bottom: 60px !important; transition:0.2s ease-in;`
                        );
                        document.getElementById("back-to-top").style.bottom =
                            "60px";
                    }
                });

                //attach the observer to the compare tray
                compareTrayMutationObserver.observe(compareTray, {
                    attributes: true,
                    attributeFilter: ["style"],
                });
            }
        }

        //remove the trade customer option from the registration form on the checkout page
        if ($("body").hasClass("woocommerce-checkout")) {
            let roleSelect = $("select#afreg_select_user_role");

            //select the retail customer option and trigger a change event
            roleSelect.val("customer").change();

            //hide the dropdown
            roleSelect.parent().hide();
        }

        //add a message to empty wish list page for logged-in users (the plugin does it only for logged-out users)
        if ($("body").is(".logged-in.wishlist")) {
            let productsList = $("ul.products");
            let isWishlistEmpty = productsList.length == 0;

            if (isWishlistEmpty) {
                let p = document.createElement("p");
                p.textContent = "Your Wish List is empty.";
                document.querySelector(".wishlist-row .col").append(p);
            }
        }
    });
    $(window).load(function () {
        check_header();

        $(window).scroll(function () {
            check_header();
        });
        $(window).resize(function () {
            check_header();
        });

        $("#alert-system").on("closed.bs.alert", function () {
            check_header();
            $("body").removeAttr("data-alert-open");
            if ($(".search-header-container").length) {
                if ($(".search-header-container").hasClass("active")) {
                    $(".search-header-container").css({ top: "" });
                }
            }

            //set the alert height variable to 0
            document.documentElement.style.setProperty("--alert-bar-height", 0);
        });

        function check_header() {
            if ($(window).scrollTop() > 1) {
                $("body .site-header").addClass("stickied");
                $("#post-footer").addClass("stickied");
            } else {
                $("body .site-header").removeClass("stickied");
                $("#post-footer").removeClass("stickied");
            }
            var getCookie = function (name) {
                var value = "; " + document.cookie;
                var parts = value.split("; " + name + "=");
                if (parts.length == 2) return parts.pop().split(";").shift();
            };
            var cookieVal = getCookie("hideAlerts");

            // added this becasue we always wanna show the alert
            let alwaysShowAlert = true;

            if (!cookieVal || alwaysShowAlert) {
                let alertBarHeight = $("#alert-system").outerHeight();

                if (alertBarHeight > 0) {
                    $("body").attr("data-alert-open", alertBarHeight.toFixed());

                    //set a css variable for the alert height
                    document.documentElement.style.setProperty(
                        "--alert-bar-height",
                        alertBarHeight + "px"
                    );
                }
            } else {
                $(".archive-header").css(
                    "margin-top",
                    $(".site-header").outerHeight()
                );
            }

            //set the top property of the sticky table on product compare page
            if (
                $("body").hasClass("compare") &&
                window.innerWidth > 767 &&
                !cookieVal
            ) {
                let adminBarHeight = $("#wpadminbar").length
                    ? $("#wpadminbar").outerHeight()
                    : 0;

                let alertBarHeight = 0;
                let compareTableTop =
                    adminBarHeight +
                    alertBarHeight +
                    $(".site-header").outerHeight();

                if ($("div.br_top_table").length) {
                    $("div.br_top_table").css(
                        "cssText",
                        `top: ${compareTableTop}px !important`
                    );
                }
            } else if (
                $("body").hasClass("compare") &&
                window.innerWidth > 767 &&
                cookieVal
            ) {
                let adminBarHeight = $("#wpadminbar").length
                    ? $("#wpadminbar").outerHeight()
                    : 0;

                let compareTableTop =
                    adminBarHeight + $(".site-header").outerHeight();

                if ($("div.br_top_table").length) {
                    $("div.br_top_table").css(
                        "cssText",
                        `top: ${compareTableTop}px !important`
                    );
                }
            } else if (
                $("body").hasClass("compare") &&
                window.innerWidth < 767
            ) {
                $("div.br_top_table").css("cssText", `top: 1px !important`);
            }

            // get the height of the alert
            let alertHeight = $("#alert-system").length
                ? $("#alert-system").outerHeight()
                : 0;

            // set the spacing on single product pages
            if ($("body").hasClass("single-product")) {
                let headerHeight;

                //check the viewport width
                if (window.innerWidth > 991) {
                    // desktop
                    if ($("header.site-header").hasClass("stickied")) {
                        headerHeight = 133;
                    } else {
                        headerHeight = 157;
                    }
                } else {
                    //mobile
                    headerHeight = 107;
                }

                let paddingTop = alertHeight + headerHeight + 20;

                $("main#content").css("padding-top", paddingTop);
            }

            // set the spacing on blog and video archive pages
            if (
                $("body").hasClass("page-video-archive") ||
                $("body").hasClass("page-post-type-archive")
            ) {
                let headerHeight;

                //check the viewport width
                if (window.innerWidth > 991) {
                    // desktop
                    if ($("header.site-header").hasClass("stickied")) {
                        headerHeight = 133;
                    } else {
                        headerHeight = 157;
                    }
                } else if (window.innerWidth > 500) {
                    //tablet
                    headerHeight = 107;
                } else {
                    //mobile
                    headerHeight = $(".header-outer-container").outerHeight();
                }

                let marginTop = alertHeight + headerHeight;

                $(".archive-header").css("margin-top", marginTop);
            }
        }
    });
    /* eslint-disable-next-line */
})(jQuery, ajax_localize);
